import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Carousel } from 'react-responsive-carousel';
import Grid from '@mui/material/Grid';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import '../../packs/registration.css';
import SlideMobileData from '../../shared/SlideMobileData';

const styles = theme => ({
  root: { background: '#fff' },
  slideItems: {
    background: 'none !important',
    color: '#000 !important',
    opacity: '1 !important',
    top: '20px',
    padding: '0px !important',
  },
  itemTitle: {
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      fontWeight: '400',
      marginBottom: '10px',
    },
  },
  firstTitle: { marginTop: '20px' },
  secondTitle: { marginTop: '25px' },
  thirdTitle: { marginTop: '10px' },
  itemDescription: {
    fontWeight: '300',
    fontSize: '0.75rem',
  },
  gridImage: { paddingRight: '5px' },
  gridDescription: { paddingLeft: '5px' },
  customerAvatar: {
    borderRadius: '100%',
    float: 'left',
    maxWidth: '90%',
  },
  testimonialGridDescription: { marginBottom: '20px' },
  southernCoGrid: { marginTop: '10px' },
  southernCoLogo: { maxWidth: '65%' },
  nationalGridLogo: { maxWidth: '70%' },
  nationalGridGrid: { marginTop: '16px' },
});

const SlideMobileVersion = ({ classes }) => (
  <Carousel
    showArrows={false}
    showThumbs={false}
    showStatus={false}
    infiniteLoop
    stopOnHover={false}
    className={classes.root}
    interval={6000}
    autoPlay
  >
    {SlideMobileData.map(data => (
      <div key="Mobile Version">
        <Grid
          container
          className={classes.slideItems}
        >
          <React.Fragment>
            <Grid item xs={5} className={classes.gridImage}>
              <img src={data.imageItem.url} alt={data.imageItem.alt} />
            </Grid>
            <Grid item xs={7} className={classes.gridDescription}>
              <Typography
                component="h1"
                variant="h4"
                align="left"
                className={
                  classNames(classes.itemTitle, classes[data.titleCss])
                }
              >
                {data.title}
              </Typography>
              <Typography component="p" align="left" className={classes.itemDescription}>
                {data.description.firstDes}
              </Typography>
              <Typography component="p" align="left" className={classes.itemDescription}>
                {data.description.secondDes}
              </Typography>
            </Grid>
          </React.Fragment>
        </Grid>
      </div>
    ))}
  </Carousel>
);

SlideMobileVersion.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(SlideMobileVersion);
